import { Account } from "types/api";
import { Option } from "types/utils";
import { TreatmentHistoryResponse } from "./components/TreatmentHistoryTable/types";

export interface UserInfoProps {
  account: Account;
  AllProgramsData?: TreatmentHistoryResponse | undefined;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ProgramsReftech?: any;
}

export interface MutationInput {
  id: number;
}
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const LeadOptions: Option<any>[] = [
  { value: "None", label: "None" },
  ...[
    { value: "a2 study", label: "a2 study" },
    { value: "Benefis", label: "Benefis" },
    { value: "CAMC", label: "CAMC" },
    { value: "Cleveland Clinic", label: "Cleveland Clinic" },
    { value: "Digital marketing", label: "Digital marketing" },
    // TODO (DEV-271): Delete this when MYB pilot is complete
    { value: "Evergreen", label: "Maintain Your Brain 2026 Pilot" },
    { value: "McLaughlin", label: "McLaughlin" },
    { value: "Millenium", label: "Millenium" },
    { value: "Mount Sinai Eldercare", label: "Mount Sinai Eldercare" },
    { value: "Physician Referral", label: "Physician Referral" },
  ].sort((a, b) => a.label.localeCompare(b.label)),
];
